import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { ITooltip } from '../../../components/1elements'

const HMapDisplaySort = ({
  currentTab,
  sortSearch,
  setSortSearch
}) => {
  const classes = useStyles()
  const [showSortOptions, setShowSortOptions] = useState(false)

  const toggleOptionMenu = () => {
    setShowSortOptions((prev) => !prev)
  }

  const handleSortItems = (sortType, sortOrder) => {
    setSortSearch({
      ...sortSearch,
      [currentTab]: {
        ...sortSearch[currentTab],
        sortType: sortType,
        sortOrder: sortOrder
      }
    })

    toggleOptionMenu()
  }

  return (
    <div className={classes.root}>
      {/* Button */}
      <ITooltip
        placement={'bottom'}
        content={'Sort Heatmaps'}
        className={classes.buttonToolTip}
      >
        <div className={classes.sortButton} onClick={toggleOptionMenu}>
          <div id="arrowUp" className={classes.arrowUp}></div>
          <div className={classes.spacer}></div>
          <div id="arrowDown" className={classes.arrowDown}></div>
        </div>
      </ITooltip>
      {/* Menu */}
      {showSortOptions && (
        <div className={classes.optionsMenu} onMouseLeave={toggleOptionMenu}>
          <div className={classes.optionsMenuWrapper}>
            <div
              className={classes.optionsMenuItem}
              onClick={() => handleSortItems('az', 'asc')}
            >
              By A-Z
            </div>
            <div
              className={classes.optionsMenuItem}
              onClick={() => handleSortItems('az', 'desc')}
            >
              By Z-A
            </div>
            <div
              className={classes.optionsMenuItem}
              onClick={() => handleSortItems('date', 'asc')}
            >
              By Date Asc
            </div>
            <div
              className={classes.optionsMenuItem}
              onClick={() => handleSortItems('date', 'desc')}
            >
              By Date Desc
            </div>
          </div>
          <div className={classes.optionMenuTriangle}></div>
        </div>
      )}
    </div>
  )
}

export default React.memo(HMapDisplaySort)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '30px',
    height: '30px',
    position: 'relative'
  },
  buttonToolTip: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box'
  },
  sortButton: {
    width: '100%',
    height: '100%',
    borderRadius: '5px',
    border: `2px solid #9A9A9A`,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#9A9A9A',
    '&:hover': {
      border: `2px solid ${theme.palette.primary.accent}`
    },
    '&:hover> [id="arrowUp"]': {
      borderBottom: `5px solid ${theme.palette.primary.accent}`
    },
    '&:hover> [id="arrowDown"]': {
      borderTop: `5px solid ${theme.palette.primary.accent}`
    }
  },
  spacer: {
    height: '3px'
  },
  arrowUp: {
    width: 0,
    height: 0,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderBottom: '5px solid #9A9A9A'
  },
  arrowDown: {
    width: 0,
    height: 0,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: '5px solid #9A9A9A'
  },
  optionsMenu: {
    position: 'absolute',
    width: '100px',
    top: 4,
    right: 35,
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    zIndex: 40
  },
  optionsMenuWrapper: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '5px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.25)',
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  optionsMenuItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '5px 10px',
    ...theme.typography.h13,
    color: theme.palette.primary.main,
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#f9f9f9'
    }
  },
  optionMenuTriangle: {
    width: 0,
    height: 0,
    borderLeft: '10px solid white',
    borderBottom: '10px solid transparent',
    borderTop: '10px solid transparent',
    position: 'absolute',
    top: 3,
    right: -7,
    zIndex: 10
  }
}))
